import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import {
  getTransactionVendorPaymentDetails,
  getTransactionBillPaymentPayeeAddress,
  getTransactionVendorReturnAuthorization,
  getTransactionBillingAddress,
} from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";


import VRAItems from "./VRA/items";
import VRARelationship from "./VRA/relationship";
import VRACommunication from "./VRA/communication";
import VRARelatedRecords from "./VRA/relatedRecords";
import VRASystemInformation from "./VRA/systemInformation";
import VRACustom from "./VRA/custom";
import VRAEft from "./VRA/eft";

export default function TransactionTypeVRA() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();

  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);
  const [payeeAddData, setPayeeAddData] = useState([]);
  const [billingData, setBillingData] = useState([]);
  const [loading, setLoading] = useState(false);

  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  const [subTabIndex, setSubTabIndex] = useState(0);

useEffect(() => {
    if (user.token) {
      getTransactionDocCreditMemoDetailsData();
    }
  }, []);

  async function getTransactionDocCreditMemoDetailsData() {
    setLoading(true);
    try {
      const { data } = await getTransactionVendorReturnAuthorization(user.token, {
        tranid: params.docNo,
      });
      setRowData(data.data.details[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  
 
 useEffect(() => {
    if (user.token) {
      getTransactionBillingAddressData();
    }
  }, [user.token]);

  async function getTransactionBillingAddressData() {
    setLoading(true);
    try {
      const { data } = await getTransactionBillingAddress(user.token, {
        id: params.docNo,
      });
      setBillingData(data.data.data[0]);
      setLoading(false);
     
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
    // setRowData([])
  }



  console.log(billingData,"billingData")
  return loading ? (
    <>
    <Typography component="h4" fontWeight={500} className="pageTitle">
           Vendor Return Authorization
          </Typography>
         
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
    <Typography component="h4" fontWeight={500} className="pageTitle">
           Vendor Return Authorization
          </Typography>
          <Typography component="p" sx={{ mb: 2 }}>
            <span className="para-no"><strong>{rowData?.transaction_id}</strong></span>{" "}
            <span className="para-no">{rowData?.displayname}</span>
            <Button className="blue-button" size="small" sx={{ ml: 1 }}>
              Credited
            </Button>
          </Typography>
      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData.map((d, i) => ( */}
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">REFERENCE NO.</p>
                  <p className="tFormName">{rowData.reference_number}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">AMOUNT</p>
                  <p className="tFormName">{rowData.amount}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">MEMO</p>
                  <p className="tFormName">{rowData.memo}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">VENDOR</p>
                  <p className="tFormName">{rowData.vendor_name}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">CURRENCY</p>
                  <p className="tFormName">{rowData.currency}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">PURCHASE REASON</p>
                  <p className="tFormName">{rowData.purchase_reason}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">PC/PROJECT</p>
                  <p className="tFormName">{rowData.pc_project}</p>
                </Grid>
           
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">EXCHANGE RATE</p>
                  <p className="tFormName">{rowData.exchangerate}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">PURCHASE ORDER APPROVAL STATUS</p>
                  <p className="tFormName">{rowData.purchase_order_approval_status}</p>
                </Grid>
                

                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">DATE</p>
                  <p className="tFormName">{rowData.date}</p>
                </Grid>
          
   
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">CREATED FROM</p>
                  <p className="tFormName">{rowData.created_from}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel checkAndTextAlign">
                        {rowData.accrual_related === "false" ||
                        rowData.accrual_related === null ||
                        rowData.accrual_related === "" ? (
                          <>
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox disabled />}
                                label=""
                              />
                            </FormGroup>
                           ACCRUAL RELATED
                          </>
                        ) : (
                          <>
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox disabled checked />}
                                label=""
                              />
                            </FormGroup>
                           ACCRUAL RELATED
                          </>
                        )}
                      </p>
                </Grid>
              </Grid>
            </>
          {/* ))} */}
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData.map((d, i) => ( */}
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SUBSIDIARY</p>
                  <p className="tFormName">{rowData.subsidiary}</p>
                </Grid>

                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">DEPARTMENT</p>
                  <p className="tFormName">{rowData.department}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SERVICE LINE</p>
                  <p className="tFormName">{rowData.service_line}</p>
                </Grid>
                <Grid item xs={12} sm={12} md={8} className="m-b-10"></Grid>
                
              </Grid>
            </>
          {/* ))} */}
        </Box>
      </Box>

{/*intercompany management */}
<Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData.map((d, i) => ( */}
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">PAIRED INTERCOMPANY TRANSACTION</p>
                  <p className="tFormName">{rowData.intercompany_transaction}</p>
                </Grid>

                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">INTERCOMPANY STATUS</p>
                  <p className="tFormName">{rowData.intercomapny_status}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                 
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">LOCATION</p>
                  <p className="tFormName">{rowData.location}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">MIDDLE MAN VAT ID</p>
                  <p className="tFormName">{rowData.middlema_vat_id}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel checkAndTextAlign">
                        {rowData.sendimportaddress_avatax === "false" ||
                        rowData.sendimportaddress_avatax === null ||
                        rowData.sendimportaddress_avatax === "" ? (
                          <>
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox disabled />}
                                label=""
                              />
                            </FormGroup>
                          SEND IMPORT ADDRESS TO AVATAX
                          </>
                        ) : (
                          <>
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox disabled checked />}
                                label=""
                              />
                            </FormGroup>
                          SEND IMPORT ADDRESS TO AVATAX
                          </>
                        )}
                      </p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">ORIGINAL INVOICE DATE</p>
                  <p className="tFormName">{rowData.original_invoice_date}</p>
                </Grid>
                <Grid item xs={12} sm={12} md={4} className="m-b-10"></Grid>
                <p className="tFormlabel">AVALARA CREATED FROM</p>
                <p className="tFormName">{rowData.avalara_created_from}</p>
              </Grid>
            </>
          {/* ))} */}
        </Box>
      </Box>
      <Box>
        <Box
          className="viewBox "
          // sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Expenses and Items" />
            <Tab label="Billing" />
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="Related Records" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
          </Tabs>

          <TabPanel value={tabIndex} index={0}>
            <VRAItems />
          </TabPanel>
          {/*------------Billing------------*/}
          <TabPanel value={tabIndex} index={1}>
            {/* {Billing_Data?.map((el, i) => ( */}
              <Box className="viewDetilsBox" >
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <p className="tFormlabel">VENDOR</p>
                    <p className="tFormName">{billingData?.vendor_name}</p>
                  </Grid>
                </Grid>
              </Box>
            {/* ))} */}
          </TabPanel>
          {/*------------Relationships------------*/}
          <TabPanel value={tabIndex} index={2}>
            {tabIndex === 2 && <VRARelationship />}
          </TabPanel>
          {/*------------Communication------------*/}
          <TabPanel value={tabIndex} index={3}>
            {tabIndex === 3 && <VRACommunication/>}
          </TabPanel>
          {/*------------Related Record------------*/}
          <TabPanel value={tabIndex} index={4}>
            {tabIndex === 4 && <VRARelatedRecords />}
          </TabPanel>
          {/*-------------System Information-----------*/}
          <TabPanel value={tabIndex} index={5}>
            {tabIndex === 5 && <VRASystemInformation />}
          </TabPanel>
          {/*-------------CUSTOM-----------*/}
          <TabPanel value={tabIndex} index={6}>
            {tabIndex === 6 && <VRACustom />}
          </TabPanel>
          {/*------------EFT-----------*/}
          <TabPanel value={tabIndex} index={7}>
          {tabIndex === 7 &&  <VRAEft tabIndexP={tabIndex} />}
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
